import { Injectable } from '@angular/core';
import { AuthState } from '../typings';
import { SessionService } from '@cemex-core/angular-services-v8';
import { IamAuthService } from '@cemex-core/msal-services-v1';

export const SS_AUTH_KEY = 'token_data';

@Injectable()
export class PersistenceService {
  constructor(
    private sessionService: SessionService,
    private iamAuthService: IamAuthService,
  ) {}

  saveAuthState(auth: AuthState) {
    const isLoginByIAM = this.iamAuthService.isLoginByIAM();

    if (!isLoginByIAM) {
      sessionStorage.setItem('access_token', auth.oauth2.access_token);
      sessionStorage.setItem('jwt', auth.jwt);
    }
    sessionStorage.setItem(SS_AUTH_KEY, JSON.stringify(auth));
    sessionStorage.setItem('country', auth.country);
    sessionStorage.setItem('user_profile', JSON.stringify(auth.profile));
    this.sessionService.updateDataSession(auth);
    // TODO Add all the necessary keys
  }

  // TODO Implement based on upto date production presistence
  getAuthState() {
    return this.sessionService.dataSession as AuthState;
  }

  removeAuthState() {
    this.sessionService.clean();
    sessionStorage.removeItem('loginByIAM');
    sessionStorage.removeItem('authIamStarted');
  }
}
